document.addEventListener('turbo:load', function(e) {
  if (!document.querySelector('[data-page="landing"]')) return;

  /* --------------------------------------------------
                Font Loading
  -------------------------------------------------- */
  const pagesLandingIndexFontLoading = function() {
    document.fonts.ready.then(function() {
      document.querySelectorAll('.font-fuji').forEach(function(element) {
        element.classList.add('font-loaded');
      });
    });
  }

  /* --------------------------------------------------
                Hero Animation
  -------------------------------------------------- */
  const pagesLandingIndexHeroAnimation = function() {
    const heroHeadline = document.querySelector('[data-gsap="hero-headline"]');
    const heroHeadlineText = heroHeadline.textContent.trim();
    const tl = gsap.timeline();

    heroHeadline.textContent = '';
    heroHeadlineText.split('').forEach(char => {
      const span = document.createElement('span');
      span.textContent = char;
      heroHeadline.appendChild(span);
    });

    tl.from(heroHeadline.children, {
      opacity: 0,
      duration: 0.01,
      stagger: 0.01,
      ease: "none"
    });
  }

  /* --------------------------------------------------
                Architects Headline Animation
  -------------------------------------------------- */
  const pagesLandingIndexArchitectsHeadlineAnimation = function() {
    const architectsHeadline = document.querySelector('[data-gsap="architects-headline"]');
    const wrapper = architectsHeadline.parentElement;

    gsap.set(architectsHeadline, { 
      y: '100%'
    });

    gsap.to(architectsHeadline, {
      y: '0%',
      duration: 0.5,
      ease: "back.out",
      scrollTrigger: {
        trigger: wrapper,
        start: "top bottom-=20",
        toggleActions: "play none none reverse"
      }
    });
  }
  
  /* --------------------------------------------------
                Review Animation
  -------------------------------------------------- */
  const pagesLandingIndexReviewAnimation = function() {
    const reviewElements = document.querySelectorAll('[data-gsap="review"]');
    const reviewsTl = gsap.timeline({
      scrollTrigger: {
        trigger: reviewElements[0]?.parentElement || reviewElements[0],
        start: "top bottom-=100",
        toggleActions: "play none none reverse"
      }
    });
    const totalAnimationTime = 1; 
    const staggerTime = totalAnimationTime / (reviewElements.length || 1);

    gsap.set(reviewElements, {
      opacity: 0,
      y: 50
    });

    reviewElements.forEach((element, index) => {
      reviewsTl.to(element, {
        opacity: 1,
        y: 0,
        duration: 0.5,
        ease: "power2.out"
      }, index * staggerTime);

      ScrollTrigger.create({
        trigger: element,
        start: "top bottom",
        end: "bottom top",
        scrub: 0.5,
        onUpdate: (self) => {
          const yPos = (self.progress * -30);
          gsap.set(element, { backgroundPositionY: yPos + "px" });
        }
      });
    });
  }

  /* --------------------------------------------------
                Footer Headline Animation
  -------------------------------------------------- */
  const pagesLandingIndexFooterHeadlineAnimation = function() {
    const footerHeadline = document.querySelector('[data-gsap="footer-headline"]');
    const footerHeadlineText = footerHeadline.textContent.trim();
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: footerHeadline,
        start: "top bottom-=100",
        toggleActions: "play none none reverse"
      }
    });

    footerHeadline.textContent = '';
    footerHeadlineText.split('').forEach(char => {
      const span = document.createElement('span');
      span.textContent = char;
      footerHeadline.appendChild(span);
    });

    tl.from(footerHeadline.children, {
      opacity: 0,
      duration: 0.05,
      stagger: 0.05,
      ease: "none"
    });
  }

  /* --------------------------------------------------
                Footer Smooth Scroll
  -------------------------------------------------- */
  const pagesLandingIndexFooterSmoothScroll = function() {
    const getAccessButtons = document.querySelectorAll('a[href="#lead-form-container"]');

    getAccessButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const footer = document.querySelector('footer');
        if (footer) {
          footer.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  }

  /* --------------------------------------------------
                Functions
  -------------------------------------------------- */
  pagesLandingIndexFontLoading();
  pagesLandingIndexHeroAnimation();
  pagesLandingIndexArchitectsHeadlineAnimation();
  pagesLandingIndexReviewAnimation();
  pagesLandingIndexFooterHeadlineAnimation();
  pagesLandingIndexFooterSmoothScroll();
});
